import React from 'react';
import { number, string, bool, func } from 'prop-types';
import CustomControl from '../CustomControl/CustomControl';

const propTypes = {
  id: number.isRequired,
  label: string.isRequired,
  onChange: func.isRequired,
  checked: bool.isRequired,
};

const defaultProps = {
  checked: false,
};

const FlowPixel = ({ id, label, onChange, checked }) => (
  <li className="pixel-list-item">
    <CustomControl
      className="custom-control-xs"
      id={`pixel-${id}`}
      label={label}
      checked={checked}
      value={id}
      onChange={onChange}
    />
  </li>
);

FlowPixel.propTypes = propTypes;
FlowPixel.defaultProps = defaultProps;

export default FlowPixel;
